import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDashboardFireRisk = defineStore(
	'dashboardFireRisk',
	() => {
		const showChartSection = ref(true)
		const showMapSection = ref(true)
		const showTableSection = ref(true)

		const daysBefore = ref(1)

		const selectedMonitoredAreasIds = ref<string[]>([])

		// O estado é persistido em localStorage e sobrevive ao logout (que só remove
		// jwt, email, username, user-modules e fotoUrl). Sem marcar de quem é a
		// seleção, o próximo login herda as fazendas do cliente anterior e o
		// dashboard busca dados que não pertencem ao usuário logado.
		const ownerCustomerId = ref<string | null>(null)

		function discardStateFromOtherCustomer(customerId: string | null) {
			if (ownerCustomerId.value === customerId) return

			ownerCustomerId.value = customerId
			selectedMonitoredAreasIds.value = []
		}

		return {
			showChartSection,
			showMapSection,
			showTableSection,
			selectedMonitoredAreasIds,
			daysBefore,
			ownerCustomerId,
			discardStateFromOtherCustomer,
		}
	},
	{
		persist: {
			storage: localStorage,
		},
	},
)
